import React from 'react';
import Hero from '../components/Hero';
import Testimonials from '../components/Testimonials';
import Timeline from '../components/Timeline';

export default function Home() {
  return (
    <>
      <Hero />
      <Timeline />
      <Testimonials />
    </>
  );
}
